// extracted by mini-css-extract-plugin
module.exports = {"main":"HowItWorks_main__8lFfU","side":"HowItWorks_side__2ohzk","text":"HowItWorks_text__2vce2","diamonds":"HowItWorks_diamonds__3jzQS"};